var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08333 3.5H3C1.89543 3.5 1 4.39543 1 5.5V12C1 14.2091 2.79086 16 5 16H10.3333C12.5425 16 14.3333 14.2091 14.3333 12V5.5C14.3333 4.39543 13.4379 3.5 12.3333 3.5H12.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1665 2.72619V2.72619C10.1665 1.77284 9.39366 1 8.44031 1H6.89269C5.93935 1 5.1665 1.77284 5.1665 2.72619V2.72619",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 9.33325L6.65639 10.8231C6.75403 10.9208 6.91232 10.9208 7.00995 10.8231L10.9998 6.83325",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.747288d2ec502b7d663c102f5d7f6e95.svg";
export { ForwardRef as ReactComponent };